"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomLoader = void 0;
const Modal_1 = require("../utils/Modal");
const DOM_1 = require("../utils/DOM");
var CustomLoader;
(function (CustomLoader) {
    class UiHandler {
        static showLoader = () => {
            const shownModal = Modal_1.Modal.Helpers.getShownModal();
            if (shownModal !== null) {
                DOM_1.DOM.Parser.getHtmlElementByClass('modal-progress', shownModal).style.display = 'block';
            }
            else if (document.getElementById('loader')) {
                DOM_1.DOM.Parser.getHtmlElement('loader').style.display = 'block';
            }
        };
        static hideLoader = () => {
            const modalProgressElements = DOM_1.DOM.Parser.getHtmlElements('modal-progress', undefined, true);
            for (let i = 0; i < modalProgressElements.length; i++) {
                modalProgressElements[i].style.display = 'none';
            }
            if (document.getElementById('loader') !== null) {
                DOM_1.DOM.Parser.getHtmlElement('loader').style.display = 'none';
            }
        };
    }
    CustomLoader.UiHandler = UiHandler;
})(CustomLoader || (exports.CustomLoader = CustomLoader = {}));
